import { render, staticRenderFns } from "./FormServiceItem.vue?vue&type=template&id=43483d38&scoped=true"
import script from "./FormServiceItem.vue?vue&type=script&lang=ts"
export * from "./FormServiceItem.vue?vue&type=script&lang=ts"
import style0 from "./FormServiceItem.vue?vue&type=style&index=0&id=43483d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43483d38",
  null
  
)

export default component.exports